import React, { useEffect } from 'react'
import { Container, Row, Col } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import CBSN_Logo from "../../asstes/images/NewHomePageLogo/CBSN-Logo.jpg";
// import NY_Weekly_Logo from "../../asstes/images/NewHomePageLogo/NY-Weekly-Cover-Page.webpjpg"
import Outlook_Logo from "../../asstes/images/NewHomePageLogo/Outlook-Logo.png";
import Daily_Scanner_Logo from "../../asstes/images/NewHomePageLogo/The-Daily-Scanner-1024x396.png";
import Abc_News_Logo from "../../asstes/images/NewHomePageLogo/abc_news.png";
import Forbes_Logo from "../../asstes/images/NewHomePageLogo/forbes-logo-png-transparent.png";
import Fox_News_Logo from "../../asstes/images/NewHomePageLogo/fox_news_logo.png";
import NBC_Logo from "../../asstes/images/NewHomePageLogo/nbc_logo.png";
import TOI_Logo from "../../asstes/images/NewHomePageLogo/times-of-india_logo.png";
import Usa_Today_Logo from "../../asstes/images/NewHomePageLogo/usa-today-full-color-logo-gannett-transparent.png";
import Meta_Press_Logo from "../../asstes/images/NewHomePageLogo/metapress-30h.png";
import Influencer_Logo from "../../asstes/images/NewHomePageLogo/influencer-logo.webp";
import Highnet_Worth_Magazine_Logo from "../../asstes/images/NewHomePageLogo/highnet-worth-magazine.webp";
import New_York_Weekly_Logo from "../../asstes/images/NewHomePageLogo/new-york-weekly.png";
import Forbes_Georgia_Logo from "../../asstes/images/NewHomePageLogo/forbes-georgia-logo.svg";
import Good_Men_Project_Logo from "../../asstes/images/NewHomePageLogo/good-men-project.png";
import Ceoworld_Magazine_Logo from "../../asstes/images/NewHomePageLogo/ceoworld-magazine.webp";
import ALITM_Wide_Logo from "../../asstes/images/NewHomePageLogo/ALITM_wide_logo.png";
import Bw_Wellbeing_Logo from "../../asstes/images/NewHomePageLogo/bw-wellbeing-logo.png";
import Tech_Bullion_Logo from "../../asstes/images/NewHomePageLogo/TechBullionLogo.webp";
import Digital_Journal_Logo from "../../asstes/images/NewHomePageLogo/Digital-Journal.webp";
import The_Guardian_Logo from "../../asstes/images/NewHomePageLogo/the-guardian.webp";
import Gbaf_Logo from "../../asstes/images/NewHomePageLogo/gbaf-logo.webp";
import Grit_Daily_Logo from "../../asstes/images/NewHomePageLogo/grit-daily.png";
import Entrepreneur_Bytes_Logo from "../../asstes/images/NewHomePageLogo/Entrepreneur-Bytes.webp";
import Destinations_Logo from "../../asstes/images/NewHomePageLogo/Destinations.png";
import Tribune_Logo from "../../asstes/images/NewHomePageLogo/the-tribune.webp";
import Latest_Y_Logo from "../../asstes/images/NewHomePageLogo/ly-logo.png";
import The_Print_Logo from "../../asstes/images/NewHomePageLogo/the-print.png";
import Ted_X_Magazine_Logo from "../../asstes/images/NewHomePageLogo/ted-X-magazine.webp";
import Under_Ceo_Logo from "../../asstes/images/NewHomePageLogo/under-30-ceo.webp";
import Suger_Mint_Logo from "../../asstes/images/NewHomePageLogo/suger-mint.png";

// ----------------------------------------------

const HomePageTogetherSection = () => {

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1200, // Animation duration (ms)
      easing: "ease-in-out", // Smooth animation effect
      once: true
    });
    // eslint-disable-next-line
  }, []);

  const logos = [
    { src: CBSN_Logo, alt: "CBSN" },
    { src: Outlook_Logo, alt: "Outlook" },
    { src: Daily_Scanner_Logo, alt: "Daily Scanner" },
    { src: Abc_News_Logo, alt: "ABC News" },
    { src: Forbes_Logo, alt: "Forbes" },
    { src: Fox_News_Logo, alt: "Fox News" },
    { src: NBC_Logo, alt: "NBC" },
    { src: TOI_Logo, alt: "TOI" },
    { src: Usa_Today_Logo, alt: "USA Today" },
    { src: Meta_Press_Logo, alt: "Metapress" },
    { src: Influencer_Logo, alt: "Influencer" },
    { src: Highnet_Worth_Magazine_Logo, alt: "Highnet Worth Magazine" },
    { src: New_York_Weekly_Logo, alt: "New York Weekly" },
    { src: Good_Men_Project_Logo, alt: "Good Men Project" },
    { src: Ceoworld_Magazine_Logo, alt: "Ceoworld Magazine" },
    { src: ALITM_Wide_Logo, alt: "ALITM Wide" },
    { src: Bw_Wellbeing_Logo, alt: "Bw Wellbeing" },
    { src: Tech_Bullion_Logo, alt: "TechBullion" },
    { src: Digital_Journal_Logo, alt: "Digital Journal" },
    { src: The_Guardian_Logo, alt: "The Guardian" },
    { src: Gbaf_Logo, alt: "Gbaf " },
    { src: Grit_Daily_Logo, alt: "Grit Daily " },
    { src: Entrepreneur_Bytes_Logo, alt: "Entrepreneur Bytes " },
    { src: Destinations_Logo, alt: "Destinations " },
    { src: Tribune_Logo, alt: "Tribune " },
    { src: Latest_Y_Logo, alt: "Latest Y" },
    { src: The_Print_Logo, alt: "The Print" },
    { src: Ted_X_Magazine_Logo, alt: "Ted X Magazine" },
    { src: Under_Ceo_Logo, alt: "Under 30 Ceo" },
    { src: Suger_Mint_Logo, alt: "Suger Mint" },
  ];

  return (
    <>
      <section className="bh-together pd-common bg-white exce-together-section" >
        <Container>
          <Row>
            <Col xs={12} md={8} lg={6} className="mx-auto">
              <div className="title-sec">
                <h2 className="title-heading text-dark">
                  As Seen on
                </h2>
              </div>
            </Col>
          </Row>
          {/* <Row className="logo-grid">
  {logos.map((logo, index) => (
    <Col
      key={index}
      xs={4}      
      sm={4}     
      md={3}     
      data-aos="fade-up"
      data-aos-delay={index * 100}
      className="d-flex justify-content-center"
    >
      <div className="services-box">
        <img src={logo.src} alt={logo.alt} />
      </div>
    </Col>
  ))}
</Row> */}

          <div className="logo-grid">
            {logos.map((logo, index) => (
              <div className='logo-container-box'>
                <div className="services-box">
                  <img src={logo.src} alt={logo.alt} />
                </div>
              </div>
            ))}
          </div>

          {/* <div className='logo-container-box' key={index} data-aos="fade-up" data-aos-delay={index * 100} >
                <div className="services-box">
                  <img src={logo.src} alt={logo.alt} />
                </div>
              </div> */}
          {/* <Row className="g-2 item-hover outer-div-logo-row">           
            {logos.map((logo, index) => (
              <Col
                key={index}
                xs={4}
                md={3}
                lg={3}
                xl={2}
                data-aos="fade-up"
                data-aos-delay={index * 100}
                className='logo-outer-div flex justify-content-center align-middle'// Adds a slight delay to each column
              >
                <div className="services-box">
                  <img src={logo?.src} alt={logo?.alt} />
                </div>
              </Col>
            ))}
          </Row> */}
        </Container>
      </section >

    </>
  )
}

export default HomePageTogetherSection
